// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__21tXQ","FooterIcons":"Footer_FooterIcons__3GuaA"};